import React, { useEffect, useState } from "react";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import { getSlug, getReportBySlug } from "../../../services/ReportService";
import { doService } from "../../../services/ServiceHelper";

const ReportInfo = ({ school, jwt }) => {
  const [_reportInfo, setReportInfo] = useState({});

  useEffect(() => {
    initReport();
  }, [school, jwt]);

  const initReport = () => {
    const slug = getSlug();
    doService(getReportBySlug(school, jwt, slug), (results) => {
      setReportInfo(results.data);
    });
  };

  return (
    <Alert severity="info" sx={{ pb: 0, mt: 1 }}>
      <AlertTitle sx={{ mb: 0 }}>Report Description</AlertTitle>

      {/* {_isLoaded === false && (
        <Skeleton variant="rectangular" width={210} height={10} />
      )} */}

      {_reportInfo.description}
    </Alert>
  );
};

export default ReportInfo;
